import { useMemo } from "react";

import { useListAvailableRoles } from "@api/rest/types-and-hooks";
import { PromptKeyedLookupSelect } from "@pages/Prompts/PromptKeyedLookupSelect";

interface PromptRoleSelectProps {
  value: string;
  onChange: (next: string) => void;
  disabled?: boolean;
}

/** Role picker — pipelines' ``prompts/roles/*.yaml`` catalog + a custom
 *  free-text fallback. Custom text isn't written as-is: the PR-opening
 *  endpoint auto-registers it under a generated key in
 *  roles/auto_registered.yaml (never touching the hand-curated
 *  base.yaml) and rewrites the prompt to reference that key — a value
 *  that matches no catalog key would otherwise reject the whole PR.
 *  See PromptKeyedLookupSelect for the shared UI. */
export const PromptRoleSelect: React.FC<PromptRoleSelectProps> = ({ value, onChange, disabled }) => {
  const { data, isLoading } = useListAvailableRoles();
  const items = useMemo(() => (data?.status === 200 ? data.data.items : []), [data]);
  return (
    <PromptKeyedLookupSelect
      value={value}
      onChange={onChange}
      items={items}
      isLoading={isLoading}
      disabled={disabled}
      allowCustom
    />
  );
};
